<template>
  <Row>
    <i-col :span="24">
      <h1>Country Profile</h1>
      <br />
      <CountrySelect
        :value="iso3"
        @on-change="iso3 => countryChanged(iso3)"
        filterable
      ></CountrySelect>
      <br />
      <br />

      <h1>Portfolios</h1>
      <br />
      <Portfolios
        :iso3="iso3"
        :conditions="{ iso3: `eq.${iso3}` }"
      ></Portfolios>
      <br />
      <br />

      <h1>Contextual Analysis</h1>
      <br />
      <ContextualsTable
        :iso3="iso3"
        :conditions="{ iso3: `eq.${iso3}` }"
      ></ContextualsTable>
      <br />
      <br />

      <h1>Significant Updates</h1>
      <br />
      <SignificantUpdatesTable
        :iso3="iso3"
        :conditions="{ iso3: `eq.${iso3}` }"
      ></SignificantUpdatesTable>
      <br />
      <br />

      <h1>Monitoring Challenges</h1>
      <br />
      <MonitoringChallenges
        :iso3="iso3"
        :conditions="{ iso3: `eq.${iso3}` }"
      ></MonitoringChallenges>
      <br />
      <br />

      <h1>Facts</h1>
      <br />
      <FactsTable :conditions="{ iso3: `eq.${iso3}` }" :limit="10"></FactsTable>
      <br />
      <br />

      <h1>Events</h1>
      <p>Events associated with country facts</p>
      <br />
      <EventsTable
        :conditions="{ iso3: `cd.{${iso3}}` }"
        :limit="10"
      ></EventsTable>
      <br />
      <br />

      <h1>Documents</h1>
      <p>Documents associated with country facts</p>
      <DocumentsTable
        table="facts_documents_view"
        :conditions="{ iso3: `eq.${iso3}` }"
        :limit="10"
      ></DocumentsTable>
      <br />
      <br />

      <h1>Contacts</h1>
      <ContactsTable
        table="contacts"
        :conditions="{
          countries_of_operation: `cs.${JSON.stringify([iso3])}`,
        }"
        :limit="10"
      ></ContactsTable>
      <br />
      <br />

      <h1>Communications</h1>
      <CommunicationsTable
        table="communications"
        :conditions="{ iso3: `eq.${iso3}` }"
        :limit="10"
      ></CommunicationsTable>
      <br />
      <br />
    </i-col>
  </Row>
</template>

<script>
import axios from "axios";
// import axios from 'axios';
import FactsTable from "@/facts/table.vue";
import DocumentsTable from "@/documents/table.vue";
import EventsTable from "@/events/table.vue";
import ContactsTable from "@/contacts/table.vue";
import ContextualsTable from "@/contextual_analysis/table.vue";
import SignificantUpdatesTable from "@/significant_updates/table.vue";
import CommunicationsTable from "@/communications/table.vue";
import MonitoringChallenges from "@/monitoring_challenges/table.vue";
import CountrySelect from "@/components/country_select.vue";
import Portfolios from "@/countries/portfolios.vue";

export default {
  components: {
    FactsTable,
    DocumentsTable,
    EventsTable,
    MonitoringChallenges,
    CountrySelect,
    ContactsTable,
    CommunicationsTable,
    ContextualsTable,
    SignificantUpdatesTable,
    Portfolios,
  },
  props: ["iso3"],
  data() {
    return {
      // current_iso3: this.iso3 || "AFG",
      country: {
        name: "",
      },
      analysis: {},
      facts: [],
    };
  },
  watch: {
    // iso3(newValue) {
    // this.current_iso3 = newValue;
    // }
  },
  mounted() {
    this.loadCountry();
  },
  methods: {
    countryChanged(iso3) {
      // console.log("countryChanged");
      this.$router.push("/countries/profiles/" + iso3);
    },
    loadCountry() {
      this.loading = true;
      axios
        .get("/psql/geo_entities", {
          params: {
            iso3: `eq.${this.iso3}`,
          },
          headers: {
            Accept: "application/vnd.pgrst.object+json",
          },
        })
        .then(response => {
          this.country = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error(error.response);
          this.errorNotice("Country information failed to load");
        });
    },
  },
};
</script>

<style lang="css"></style>
